<mat-card class="card">
  <div class="card-container">
    <app-logo></app-logo>
    <app-form></app-form>
  </div>
</mat-card>
